import { AfterViewInit, Component, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AffiliateService } from '@app/core/affiliate.service';
import { HttpClient } from '@angular/common/http';
import { ModalService } from '@app/shared/modal.service';
import { Subscription } from 'rxjs/Subscription';
import { JackpotService } from '@app/core/jackpot.service';

@Component({
  selector: 'app-free-spins-modal',
  template: `
    <!-- <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div> -->

    <h3>You got {{ freeSpins }} Free spins</h3>
    <img src="/assets/images/v2/free-spins-coins.svg" height="150" class="free-spins-claim-img" />
    <!-- <div class="div-block-4"> -->
    <!-- <img src="/assets/images/v2/free-spins-icon-bar.svg" width="40" class="free-spins-popup-icon" /> -->
    <!-- <h4 class="no-margin">{{ freeSpins }} Free spins</h4> -->
    <!-- </div> -->
    <app-form-button class="default" (click)="close()">Claim free spins</app-form-button>
  `,
  styles: [
    `
      :host {
        text-align: center;
        align-items: center;
        display: flex;
        flex-direction: column;
        background-image: url('/assets/images/v2/freespins-glow.png');
        background-position: 50% 50%;
        background-size: cover;
        background-repeat: no-repeat;
      }

      .div-block-4 {
        display: -ms-flexbox;
        display: flex;
        margin-bottom: 30px;
        margin-bottom: 30px;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
      }
      .free-spins-popup-icon {
        margin-right: 10px;
      }
      h4 {
        margin: 0;
      }

      .free-spins-claim-img {
        margin-top: 20px;
        margin-bottom: 20px;
      }
    `,
  ],
})
export class ModalFreeSpinsComponent extends AnimatedModalComponent implements AfterViewInit {
  form: FormGroup;
  loading = false;
  errors = null;
  person: any = '';
  _service: ModalService;
  freeSpins: number = 10;

  constructor(
    private ref: NgbActiveModal,
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    protected elRef: ElementRef,
    protected renderer: Renderer2,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected http: HttpClient
  ) {
    super(elRef, renderer);
  }

  ngAfterViewInit() {}

  public close(): void {
    this.auth.guestWon = true;
    this.ref.close(0);
  }

  public reject(): void {
    this.auth.guestWon = true;
    this.ref.dismiss(1);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/free-spins-modal.component.ts